<template>
  <form-edit-activity :form-type="FORM_TYPE" ref="formEditor"
                      :mode="mode"
                      :entity-id="entityId"
                      @form-created="formCreated"
  >
    <template v-slot:mixins v-if="form">
      <form-mixin after="eid">
        Yo in col after eid!
      </form-mixin>

      <form-mixin after="">
        Yo in col after nothing!
      </form-mixin>

      <form-mixin after="code">
            Yo in col!
      </form-mixin>

      <form-mixin after="Age" :row="true">
            Yo in row!
      </form-mixin>

      <form-mixin after="Multiline Text Field" :row="true">
        <reach-input
            label="MixinField"
            :formField="form.fields.mixinField"
            :read-only="form.fields.mixinField.readOnly"
        >
        </reach-input>
      </form-mixin>

      <!--
        custom tabs
      -->
    </template>
  </form-edit-activity>
</template>

<script>
import Activity from "@/activity/Activity";
import PermissionsSet from "@/server/PermissionsSet";
import Log from "@/utils/Log";
import DialogManager from "@/utils/DialogManager";
import FormsListActivity from "@/activity/templates/layouts/forms/FormsListActivity";
import FormsLoader from "@/components/forms/FormsLoader";
import BookHealthcheck from "@/server/com/silkplm/model/healthcheck/BookHealthcheck";
import FormEditActivity from "@/activity/templates/layouts/forms/FormEditActivity";
import FormMixin from "@/components/forms/customizations/mixins/FormMixin";
import ReachInput from "@/components/inputs/ReachInput";

const FORM_TYPE = BookHealthcheck;

export default {
  name: "BookHealthcheckEditor",
  components: {ReachInput, FormMixin, FormEditActivity, FormsListActivity},
  permission: () => FormsLoader.formPermission(FORM_TYPE),

  props:{
    entityId: {default: null},
    mode: {type: String, default:"NEW"}
  },

  created() {

  },

  methods: {
    ...Activity.methods,

    /** @type {FormModel} form */
    formCreated(form){
      this.form = form;
      this.form.validatedFieldByName('dictStatus').onChange((newVal)=>{
      });
    },

    async customAdd(){
      Log.debug("Wow!");
      await DialogManager.info("New clicked", "A new button was clicked");
    },

    async customDetails(){
      Log.debug("Wow!");
      await DialogManager.info("New clicked", "A new button was clicked");
    },

    async canClose(){
      return await this.$refs.formEditor?.canClose();
    }

  },
  data:function(){return {
    FORM_TYPE,
    /** @type {FormModel} */
    form:null,
    permissions: new PermissionsSet(),
    formConfig: FormsLoader.detectFormConfig(FORM_TYPE),
    formId: FormsLoader.detectFormConfig(FORM_TYPE).formId
  }}
}
</script>
